import * as React from "react";

import { cn } from "@/lib/helper/utils";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "px-[6px] py-1 file:text-foreground  placeholder:text-[#4D4D4D] selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-[50px] placeholder:font-normal w-full min-w-0 rounded-md border bg-transparent text-base transition-[color,box-shadow] outline-none file:inline-flex file:h-[50px] file:border-0 file:bg-transparent file:text-lg file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
        "focus-visible:border-primary  focus-visible:border-[1px]",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        className
      )}
      {...props}
    />
  );
}

export { Input };
